import { useState, useCallback } from 'react'
import { Autocomplete } from './Autocomplete'
import debounce from 'lodash/debounce'
import { useGithubUsers } from '@/hooks/useGithubUsers.ts'

export function GitHubUserAutocomplete({
  disabled,
  onSelect,
}: {
  disabled: boolean
  onSelect: (username: string, avatarUrl: string) => void
}) {
  const [searchValue, setSearchValue] = useState('')
  const [debouncedSearchValue, setDebouncedSearchValue] = useState('')

  const debouncedSetSearchValue = useCallback(
    debounce((value: string) => {
      setDebouncedSearchValue(value)
    }, 300),
    [],
  )

  const { data: users = [], isLoading, error } = useGithubUsers({ debouncedSearchValue })
  const fakeIsLoading = isLoading || debouncedSearchValue !== searchValue

  return (
    <Autocomplete
      onSelectedValueChange={(user) => {
        if (user) {
          onSelect(user.value, user.avatarUrl)
          setSearchValue('')
          setDebouncedSearchValue('')
        }
      }}
      searchValue={searchValue}
      onSearchValueChange={(value) => {
        setSearchValue(value)
        debouncedSetSearchValue(value)
      }}
      items={users}
      isLoading={fakeIsLoading}
      placeholder="Search GitHub username"
      disabled={disabled}
      error={error}
    />
  )
}
